import React, { useState } from "react";

const VideoCard = ({ video }) => {
  const [showModal, setShowModal] = useState(false);

  const getYoutubeId = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get("v");
    } catch {
      return "";
    }
  };

  const youtubeId = getYoutubeId(video.videoUrl);

  return (
    <>
      <div className="col-lg-3 col-md-4 mb-4">
        <div
          className="card h-100 shadow-sm"
          style={{ cursor: "pointer" }}
          onClick={() => setShowModal(true)}
        >
          <img
            src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
            className="card-img-top"
            alt={video.title}
          />
          <div className="card-body">
            <h5 className="card-title">{video.title}</h5>
            <p className="card-text">{video.description}</p>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          onClick={() => setShowModal(false)}
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{video.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={`https://www.youtube.com/embed/${youtubeId}`}
                  title={video.title}
                  width="100%"
                  height="400"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoCard;
